"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AreaLibraryPage = AreaLibraryPage;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var area_library_1 = require("../components/dashboard/area-library");
var text_component_1 = require("../components/ui/text-component");
var area_library_2 = require("../features/apis/area-library");
var client_scoped_query_1 = require("../utils/client-scoped-query");
var use_debounce_1 = require("../utils/use-debounce");
var use_has_permission_1 = require("../utils/use-has-permission");
function AreaLibraryPage() {
    var _this = this;
    var clientId = (0, client_scoped_query_1.useActiveClientId)();
    var canCreateAreaLibrary = (0, use_has_permission_1.useHasPermission)("create_area_library");
    var canUpdateAreaLibrary = (0, use_has_permission_1.useHasPermission)("update_area_library");
    var canDeleteAreaLibrary = (0, use_has_permission_1.useHasPermission)("delete_area_library");
    var _a = (0, react_1.useState)(""), search = _a[0], setSearch = _a[1];
    var debouncedSearch = (0, use_debounce_1.useDebouncedValue)(search);
    var _b = (0, react_1.useState)(false), isAddModalOpen = _b[0], setIsAddModalOpen = _b[1];
    var _c = (0, react_1.useState)(null), editingAreaLibrary = _c[0], setEditingAreaLibrary = _c[1];
    var _d = (0, react_1.useState)(null), deletingAreaLibrary = _d[0], setDeletingAreaLibrary = _d[1];
    var _e = (0, area_library_2.useGetAreaLibrariesQuery)({ clientId: clientId, search: debouncedSearch || undefined }, { skip: !clientId }), data = _e.data, isLoading = _e.isLoading, isFetching = _e.isFetching, isError = _e.isError, error = _e.error, refetch = _e.refetch;
    var _f = (0, area_library_2.useReorderAreaLibrariesMutation)(), reorderAreaLibraries = _f[0], isReordering = _f[1].isLoading;
    var reorderInFlightRef = (0, react_1.useRef)(false);
    var _g = (0, react_1.useState)([]), orderedAreaLibraries = _g[0], setOrderedAreaLibraries = _g[1];
    var _h = (0, react_1.useState)(""), reorderError = _h[0], setReorderError = _h[1];
    (0, react_1.useEffect)(function () {
        var _a;
        setOrderedAreaLibraries((_a = data === null || data === void 0 ? void 0 : data.content) !== null && _a !== void 0 ? _a : []);
    }, [data]);
    var canReorderAreaLibraries = canUpdateAreaLibrary && !debouncedSearch && !isReordering;
    var handleReorder = function (reordered) { return __awaiter(_this, void 0, void 0, function () {
        var previousOrder, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!clientId || reorderInFlightRef.current) {
                        return [2 /*return*/];
                    }
                    previousOrder = orderedAreaLibraries;
                    reorderInFlightRef.current = true;
                    setReorderError("");
                    setOrderedAreaLibraries(reordered);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, reorderAreaLibraries({ clientId: clientId, items: reordered.map(function (areaLibrary, index) { return ({ id: areaLibrary.id, order: index + 1 }); }) }).unwrap()];
                case 2:
                    _b.sent();
                    return [3 /*break*/, 5];
                case 3:
                    _a = _b.sent();
                    setOrderedAreaLibraries(previousOrder);
                    setReorderError("Unable to save the new order. Please try again.");
                    return [3 /*break*/, 5];
                case 4:
                    reorderInFlightRef.current = false;
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    return ((0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col gap-4", children: [(0, jsx_runtime_1.jsx)(area_library_1.AreaLibraryHeader, { search: search, onSearchChange: setSearch, onAddAreaLibrary: function () { return setIsAddModalOpen(true); }, canAddAreaLibrary: canCreateAreaLibrary, isReorderBlockedBySearch: canUpdateAreaLibrary && !!debouncedSearch }), reorderError && (0, jsx_runtime_1.jsx)(text_component_1.TextComponent, { size: "small", color: "red-600", label: reorderError }), (0, jsx_runtime_1.jsx)(area_library_1.AreaLibraryTable, { areaLibraries: orderedAreaLibraries, isLoading: isLoading, isFetching: isFetching, isError: isError, error: error, onRetry: refetch, onEdit: setEditingAreaLibrary, onDelete: setDeletingAreaLibrary, onReorder: handleReorder, canEdit: canUpdateAreaLibrary, canDelete: canDeleteAreaLibrary, canReorder: canReorderAreaLibraries }), (0, jsx_runtime_1.jsx)(area_library_1.AddAreaLibraryModal, { isOpen: isAddModalOpen, clientId: clientId, onClose: function () { return setIsAddModalOpen(false); }, onCreated: refetch }), (0, jsx_runtime_1.jsx)(area_library_1.EditAreaLibraryModal, { areaLibrary: editingAreaLibrary, onClose: function () { return setEditingAreaLibrary(null); }, onUpdated: refetch }), (0, jsx_runtime_1.jsx)(area_library_1.DeleteAreaLibraryModal, { areaLibrary: deletingAreaLibrary, onClose: function () { return setDeletingAreaLibrary(null); }, onDeleted: refetch })] }));
}
